<!-- Hidden table for PDF / XLS export -->
<div class="d-none" #print_table>
	<table class="table table-fixed table-sm">
		<thead>
			<tr>
				<th>#</th>
				<th>Vendor ID</th>
				<th>Name</th>
				<th>Terms</th>
				<th>Transactions</th>
				<th>Total Amount</th>
				<th>Avg Delivery</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let r of sortedData; let i = index">
				<td>{{ i + 1 }}</td>
				<td>{{ r.supplierid }}</td>
				<td>{{ r.suppname }}</td>
				<td>{{ r.termsname }}</td>
				<td>{{ r.transcount | number }}</td>
				<td>{{ r.totalamount | currency }}</td>
				<td>{{ r.avgdelivery | currency }}</td>
			</tr>
		</tbody>
	</table>
</div>

<div class="container-fluid tp-box vd-host" [@flipState]="flip">
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip === 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				[title]="cardTitle"
				icon="trending_up"
				accent="warning"
				[value]="data.length"
				[loading]="loading"
				[showView]="!loading"
				(view)="toggleFlip(data, title)">
			</app-dashboard-stat-card>
		</div>
	</div>

	<div class="row tp-box__side tp-box__back" *ngIf="flip === 'active'">
		<div class="cw-wrap vd-wrap tv-expanded" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">trending_up</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">{{ cardTitle }}</span>
				</div>
				<div class="vd-toolbar">
					<button class="btn btn-success btn-sm" type="button" (click)="exportXls()" [disabled]="loading || !data.length || sending">
						<i class="fa fa-file-excel-o"></i>
					</button>
					<button class="btn btn-danger btn-sm" type="button" (click)="exportPdf()" [disabled]="loading || !data.length || sending">
						<i class="fa fa-file-pdf-o"></i>
					</button>
				</div>
			</div>

			<div class="cw-body">
				<form [formGroup]="searchForm" class="tv-form">
					<div class="tv-toolbar">
						<mat-form-field appearance="outline" class="tv-date-range">
							<mat-label>Date From</mat-label>
							<input matInput [matDatepicker]="pickerFrom" formControlName="datefrom" (dateChange)="load()" />
							<mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
							<mat-datepicker #pickerFrom></mat-datepicker>
						</mat-form-field>
						<mat-form-field appearance="outline" class="tv-date-range">
							<mat-label>Date To</mat-label>
							<input matInput [matDatepicker]="pickerTo" formControlName="dateto" (dateChange)="load()" />
							<mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
							<mat-datepicker #pickerTo></mat-datepicker>
						</mat-form-field>

						<mat-form-field appearance="outline" class="tv-limit-field">
							<mat-label>Limit</mat-label>
							<input matInput type="number" formControlName="limit" (change)="load()" min="1" max="500" />
						</mat-form-field>

						<button mat-raised-button color="accent" type="button" (click)="load()" [disabled]="loading">
							<mat-icon>refresh</mat-icon> Refresh
						</button>

						<span *ngIf="loading" class="tv-spinner" aria-hidden="true">
							<svg class="spinner" width="28" height="28" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
								<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
							</svg>
						</span>
					</div>

					<div class="tv-filter-row">
						<mat-form-field appearance="outline" class="tv-filter-field">
							<mat-label>Vendor Type</mat-label>
							<mat-select formControlName="supptype" (selectionChange)="load()">
								<mat-option value="">All</mat-option>
								<mat-option *ngFor="let t of vendorTypes" [value]="t.typeid">{{ t.typename }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</form>

				<div class="tv-results-heading" *ngIf="!loading && data.length">
					<div class="tv-results-heading__dates">{{ getReportDateRangeCaption() }}</div>
					<p class="tv-results-heading__hint">
						Ranked by total invoiced amount in range · Limit {{ searchForm.get('limit')?.value || 100 }}
					</p>
					<div class="tv-global-stats">
						<div class="tv-stat">
							<span class="tv-stat__label">Total Amount</span>
							<span class="tv-stat__value">{{ globalTotalAmount | currency }}</span>
						</div>
						<div class="tv-stat">
							<span class="tv-stat__label">Total Transactions</span>
							<span class="tv-stat__value">{{ globalTotalTransactions | number }}</span>
						</div>
						<div class="tv-stat tv-stat--highlight">
							<span class="tv-stat__label">Avg Delivery</span>
							<span class="tv-stat__value">{{ globalAvgDelivery | currency }}</span>
						</div>
					</div>
				</div>

				<p *ngIf="!loading && !data.length" class="text-muted mb-0 mt-3">No vendors match the current filters.</p>

				<div class="tv-list" *ngIf="!loading && sortedData.length">
					<div class="tv-list-header">
						<span class="tv-col-rank">#</span>
						<span class="tv-col-id pointer" (click)="sortBy('supplierid')">
							Vendor ID
							<i *ngIf="sortColumn === 'supplierid'" class="fa" [ngClass]="sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down'"></i>
						</span>
						<span class="tv-col-name pointer" (click)="sortBy('suppname')">
							Name
							<i *ngIf="sortColumn === 'suppname'" class="fa" [ngClass]="sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down'"></i>
						</span>
						<span class="tv-col-terms pointer" (click)="sortBy('termsname')">
							Terms
							<i *ngIf="sortColumn === 'termsname'" class="fa" [ngClass]="sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down'"></i>
						</span>
						<span class="tv-col-trans text-end pointer" (click)="sortBy('transcount')">
							Transactions
							<i *ngIf="sortColumn === 'transcount'" class="fa" [ngClass]="sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down'"></i>
						</span>
						<span class="tv-col-total text-end pointer" (click)="sortBy('totalamount')">
							Total Amount
							<i *ngIf="sortColumn === 'totalamount'" class="fa" [ngClass]="sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down'"></i>
						</span>
						<span class="tv-col-avg text-end pointer" (click)="sortBy('avgdelivery')">
							Avg Delivery
							<i *ngIf="sortColumn === 'avgdelivery'" class="fa" [ngClass]="sortDirection === 'asc' ? 'fa-caret-up' : 'fa-caret-down'"></i>
						</span>
					</div>

					<div class="tv-row" *ngFor="let r of sortedData; let i = index">
						<span class="tv-col-rank">
							<span class="tv-rank-badge" [ngClass]="{'tv-rank-gold': i === 0, 'tv-rank-silver': i === 1, 'tv-rank-bronze': i === 2}">
								{{ i + 1 }}
							</span>
						</span>

						<span class="tv-col-id">{{ r.supplierid }}</span>

						<span class="tv-col-name">
							<span class="tv-vendor-name">{{ r.suppname }}</span>
						</span>

						<span class="tv-col-terms">{{ r.termsname || '—' }}</span>

						<span class="tv-col-trans text-end">{{ r.transcount | number }}</span>

						<span class="tv-col-total text-end">
							<strong>{{ r.totalamount | currency }}</strong>
						</span>

						<span class="tv-col-avg text-end">{{ r.avgdelivery | currency }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
